// utils/broadcast.js
const channel = new BroadcastChannel('session_channel');

export const broadcastMessage = (type) => {
  channel.postMessage({ type });
};

export const listenMessage = (onMessage) => {
  channel.onmessage = (event) => {
    onMessage(event.data);
  };
};